import Window from "../window/Window";

function About({ functions }) {
  const data = [
    "Rendre tous les boutons fonctionnels",
    "Faire un menu en haut",
    "Améliorer la barre des tâches",
    "Ajouter des liens",
    "Donner la possibilité de télécharger en PDF"
  ];

  return (
    <Window
      id="about"
      title="À propos du site"
      
    >

    <h3>Pour obtenir mon CV en PDF</h3>
    <p>Vous pouvez sois le généré a partir de cette page avec CTRL + P puis selectionnez Enregistrer au format PDF, puis Orientation: Portrait, Taille du papier: A4, Marges: Aucune et cochez bien "Imprimer les arrière-plans"</p>
    <p>Sois le télécharger ici : <a href="https://github.com/Pierre-LHOSTE/Pierre-LHOSTE.github.io/raw/assets/Pierre_LHOSTE_CV.pdf">https://github.com/Pierre-LHOSTE/Pierre-LHOSTE.github.io/raw/assets/Pierre_LHOSTE_CV.pdf</a></p>
    <br />
    <h3>Détails</h3>
    <p>API utilisé : react.js, node-sass</p>
    <p>Code source : Bientôt, pour le moment seul le build est disponible</p>
    <p>Liens du repo : <a href="https://github.com/pierre-lhoste/pierre-lhoste.github.io/">https://github.com/pierre-lhoste/pierre-lhoste.github.io/</a></p>
    <p>Les icônes des fenêtres proviennent de <a href="https://tablericons.com/"> https://tablericons.com/</a></p>
    <p>Le fond d'écran est un fond d'écran Apple</p>

    <br/>
    </Window>
  );
}

export default About;
